/*
 * @Author: zhaihaooran
 * @Date: 2021-03-16 14:05:33
 * @LastEditors: OBKoro1
 * @LastEditTime: 2021-03-27 19:42:37
 * @FilePath: /umu_mobile/src/businessCommon/hooks/useUserInfo.ts
 */
import { useState, useEffect } from 'react';
import API from '@umu/umu-api';
import { fetch } from '@umu/umu-fetch';
import { IUserInfo } from '@umu/umu-types';

let initUserInfo = {
    umu_id: '',
    achievement_url: '',
    email: '',
    enterprise_info: {},
    person_home_url: '',
    phone: '',
    phone_number: '',
    remark: '',
    student_id: '',
    login_name: '',
    student_info: {},
    teacher_id: '',
} as IUserInfo;

export function useUserInfo(): [IUserInfo, boolean] {
    const [isReady, setIsReady] = useState(false);
    const [userInfo, setUserInfo] = useState({} as IUserInfo);
    useEffect(() => {
        if (initUserInfo.umu_id.length !== 0) {
            setUserInfo(initUserInfo);
            setIsReady(true);
            return;
        }
        fetch.get(API.Path.GET_USER_INFO.url, {}, { silent: true }).then((response: { data?: IUserInfo }) => {
            if (response.data) {
                initUserInfo = response.data;
                setUserInfo(response.data);
            }
            setIsReady(true);
        });
    }, []);
    return [userInfo, isReady];
}
